import "./Reinigung.module.css";
import Header from "@/reusable_sections/Header";
import Seometa from "./sections/Seometa";
import EnvironmentallyFriendlyCleaningForYourProperty from "./sections/EnvironmentallyFriendlyCleaningForYourProperty";
import SeeTheDifferenceBeforeAfterCleaning from "./sections/SeeTheDifferenceBeforeAfterCleaning";
import Footer from "@/reusable_sections/Footer";
export default function ReinigungPage() {
  return <div>
      <Seometa />
      <Header />
      <EnvironmentallyFriendlyCleaningForYourProperty />
      <SeeTheDifferenceBeforeAfterCleaning />
      <Footer />
    </div>;
}